import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useGetUsuariosPaginatedMutation } from '../../../store/api/endpoints/usuariosApiSlice'

import { getUsuarioPermisos } from '../../../store/slices/auth'

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'

import ButtonIcon from '../../elementos/ButtonIcon'
import HeaderVista from '../../elementos/HeaderVista'
import TablaPaginada from '../../elementos/TablaPaginada'

import AddIcon from '@mui/icons-material/Add'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'

import SearchIcon from '@mui/icons-material/Search'


export default function Usuarios() {

    const permisosDelUsuario = useSelector(getUsuarioPermisos)

    const thead = []
    thead.push({ label: "Nombre", align: "left", ordenable: true })
    thead.push({ label: "Email", align: "left", ordenable: true })
    thead.push({ label: "Whatsapp", align: "left", ordenable: true })
    thead.push({ label: "Acciones", align: "center", ordenable: false })

    const tbody = []
    tbody.push({ tipo: "texto", valor: "nombre" })
    tbody.push({ tipo: "texto", valor: "email" })
    tbody.push({ tipo: "texto", valor: "tel_whatsapp" })
    let botones = []
    botones.push({ color: "primary", icono: <SearchIcon />, ruta: "/usuarios/", valor: '_id' })
    tbody.push({ tipo: "botones", valor: botones })


    if (permisosDelUsuario.indexOf(2) == -1) return (<p>No tienes acceso a visualizar los planes.</p>)

    return (<>
        <HeaderVista
            titulo={
                <Breadcrumbs aria-label="breadcrumb">
                    <Typography color="text.primary">Usuarios</Typography>
                </Breadcrumbs>
            }
            icon={<PeopleAltIcon />}
            end={(permisosDelUsuario.indexOf(6) > -1 ? <ButtonIcon
                variant="outlined"
                size="small"
                color="primary"
                startIcon={<AddIcon />}
                to="/usuarios/crear"
            >
                Nuevo
            </ButtonIcon> : '')}
        />
        <TablaPaginada
            api={useGetUsuariosPaginatedMutation}
            thead={thead}
            tbody={tbody}
            orderDefault={[0,0]}
        />
    </>)

}

